import { observer } from "mobx-react-lite";
import { ActivityDetailsItem } from "../../../ActivityDetailsItem/ActivityDetailsItem";
import { useActionDetails } from "../../hooks/useActionDetails";
import type { ActionGroupProps } from "../../types";
import { ActionDetailsContainer } from "../common/ActionDetailsContainer";
import { PdfLink } from "./PdfLink";
import { extractPdfInfo } from "./utils";
import { WithFindWrapper } from "../common/WithFindWrapper/WithFindWrapper";

export const GenerateLoopingPdfGroup = observer<ActionGroupProps>(
  ({
    action,
    recordJobData,
    recordJobDataByDetailsId,
    recordJobIds,
    onRecordClick,
    onDetailsClick,
  }) => {
    const { status, errorMessage, actionLabel } = useActionDetails(action);

    return (
      <ActionDetailsContainer
        label={actionLabel}
        status={status}
        errorMessage={errorMessage}
        onDetailsClick={onDetailsClick}
      >
        <WithFindWrapper
          recordJobData={recordJobData}
          recordJobDataByDetailsId={recordJobDataByDetailsId}
          recordJobIds={recordJobIds}
          onRecordClick={onRecordClick}
        >
          {({ recordJobData }) => {
            const { title, link } = extractPdfInfo(recordJobData);

            return (
              <>
                <ActivityDetailsItem label="Pdf Document">
                  {link ? (
                    <PdfLink title={title} link={link} />
                  ) : (
                    <span>{title}</span>
                  )}
                </ActivityDetailsItem>
              </>
            );
          }}
        </WithFindWrapper>
      </ActionDetailsContainer>
    );
  },
);
